import { Download } from "@mui/icons-material";
import { LoadingButton } from "@mui/lab";
import { Dialog, DialogTitle, Stack, Typography } from "@mui/material";
import { useState } from "react";
import API from "../../../../services/API";

export default function DocumentsModal({session, onClose}){

    const [loading, setLoading] = useState(null) 

    const handleClick = doc => {

        setLoading(doc.title)

        const endpoint = doc.endpoint.replace(':id', session?.id);

        const fileName = doc.getFileName(session);

        API.download(endpoint, fileName)
            .catch(e => console.log(e))
            .finally(() => setLoading(null))

    }

    return (
        <Dialog onClose={onClose} open={session ? true : false}>

            <DialogTitle>Session {session?.number}</DialogTitle>

            <Stack sx={{minWidth: 300}}>

                {docs.filter(doc => doc.isAvailable(session)).map(doc => 
                    <Stack 
                        key={doc.title} 
                        direction="row" 
                        spacing={2} 
                        alignItems="center"
                        onClick={() => handleClick(doc)}
                        sx={{p: 1}}
                    >

                        <LoadingButton
                            loading={loading === doc.title}
                        >
                            <Download />
                        </LoadingButton>
                            
                        <Typography color="text.secondary" variant="body2">
                            {doc.title}
                        </Typography>

                    </Stack>    
                )}

            </Stack>

        </Dialog>
    )
}

const docs = [
    {
        title: 'Participations ZIP', 
        endpoint: "/dpc/sessions/:id/participation.zip", 
        getFileName: (session) => `Attestation_sur_l_honneur-${session?.action?.id}-${session?.number}.zip`,
        isAvailable: (session) => true
    },
    {
        title: 'Participations PDF', 
        endpoint: "/dpc/sessions/:id/participation.pdf",
        getFileName: (session) => `Attestation_sur_l_honneur-${session?.action?.id}-${session?.number}.pdf`,
        isAvailable: (session) => true
    },
    {
        title: 'Logs HTML', 
        endpoint: "/dpc/sessions/:id/logs.html",
        getFileName: (session) => `Logs-${session?.action?.id}-${session?.number}.html`,
        isAvailable: (session) => true
    },
    {
        title: 'Traçabilité CSV', 
        endpoint: "/dpc/sessions/:id/traceability.csv",
        getFileName: (session) => `Tracabilite-${session?.action?.id}-${session?.number}.csv`,
        isAvailable: (session) => true
    },
    {
        title: 'Synthèse PDF', 
        endpoint: "/dpc/sessions/:id/synthesis.pdf",
        getFileName: (session) => `Synthese_de_suivi-${session?.action?.id}-${session?.number}.pdf`,
        isAvailable: (session) => true
    },
    {
        title: 'Facture PDF', 
        endpoint: "/dpc/sessions/:id/invoice.pdf",
        getFileName: (session) => `Facture-${session?.action?.id}-${session?.number}.pdf`,
        isAvailable: (session) => true
    },
    {
        title: 'Logs Classe Virtuelle Zoom CSV', 
        endpoint: "/dpc/sessions/:id/zoom.csv",
        getFileName: (session) => `Classe_Virtuelle-${session?.action?.id}-${session?.number}.csv`,
        isAvailable: (session) => !!session?.live
    },
    {
        title: 'Synthèse de Classe Virtuelle PDF', 
        endpoint: "/dpc/sessions/:id/live.pdf",
        getFileName: (session) => `Synthese_de_Classe_Virtuelle-${session?.action?.id}-${session?.number}.pdf`,
        isAvailable: (session) => !!session?.live
    },
];